<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">ISPIS PLANA PROIZVODNJE I POTREBNIH SIROVINA</h2>

  <div class="content-block if-filters">
    <div>
      <span>Datum od</span>
      <dx-date-box
        pickerType="calendar"
        displayFormat='dd.MM.yyyy.'
        placeholder="Odaberite datum"
        [value]="today"
        [width]="160"
        (onValueChanged)="promjenaDatumOd($event)"
      >
      </dx-date-box>
    </div>
    <div>
      <span>Datum do</span>
      <dx-date-box
        pickerType="calendar"
        displayFormat='dd.MM.yyyy.'
        placeholder="Odaberite datum"
        [value]="today"
        [width]="160"
        (onValueChanged)="promjenaDatumDo($event)"
      >
      </dx-date-box>
    </div>
    <div>
      <span>Skladište sirovina</span>
      <dx-select-box
        #selectBoxSkladisteSirovina
        [disabled]="false"
        [items]="skladistaSirovina"
        [value]="skladistaSirovina[0].idposlovnica"
        valueExpr="idposlovnica"
        displayExpr="po_naziv"
        [width]="300"
        (onValueChanged)="promjenaSkladista($event)"
      >
      </dx-select-box>
    </div>
    <div>
      <span>Smjena</span>
      <dx-select-box
        [disabled]="false"
        [items]="smjene"
        [value]="smjene[0].id"
        valueExpr="id"
        displayExpr="naziv"
        [width]="100"
        (onValueChanged)="promjenaSmjene($event)"
      >
      </dx-select-box>
    </div>
    <div>
      <span>Pogon</span>
      <dx-select-box
        #selectBoxPogon
        [disabled]="false"
        [items]="pogoni"
        [value]="pogoni[0].id"
        valueExpr="id"
        displayExpr="naziv"
        [width]="200"
        (onValueChanged)="promjenaPogona($event)"
      >
      </dx-select-box>
    </div>
    <div>
      <span>Linija</span>
      <dx-select-box
        #selectBoxLinija
        [disabled]="false"
        [items]="linije"
        [value]="linije[0].id"
        valueExpr="id"
        displayExpr="naziv"
        [width]="250"
        (onValueChanged)="promjenaLinije($event)"
      >
      </dx-select-box>
    </div>
    <div *ngIf="planovi.length">
      <dx-button
        [disabled]="pravaZaTrenutniPogled != 2"
        text="Print"
        icon="pdffile"
        hint="PDF"
        (onClick)="createPdf()"
      >
      </dx-button>
    </div>

    <div *ngIf="planovi_novi_nacin.length">
      <dx-button
        [disabled]="pravaZaTrenutniPogled != 2"
        text="Print novi"
        icon="pdffile"
        hint="PDF"
        (onClick)="createPdf_novi_nacin()"
      >
      </dx-button>
    </div>
  </div>

  <div class="customTable nadzornaPloca m-40 toolbar45">
    <div id="data-grid-demo">
      <dx-data-grid
        id="gridContainer"
        [dataSource]="planovi"
        [showColumnLines]="true"
        [wordWrapEnabled]="true"
        keyExpr="idplanproizvodnje"
        [showBorders]="false"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onCellPrepared)="onCellPrepared($event)"
      >
        <div *dxTemplate="let data of 'naslovTablice'">
          <div class="naslov">
            <h2 class="mb-0">Proizvodi</h2>
          </div>
        </div>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxi-column
          dataField="ar_sifra"
          caption="Šifra proizvoda"
          [width]="150"
        ></dxi-column>
        <dxi-column
          dataField="ar_naziv"
          caption="Proizvod"
          [minWidth]="300"
        ></dxi-column>
        <dxi-column
          dataField="ukupnakolicina"
          caption="Komada"
          [width]="100"
        ></dxi-column>
        <dxi-column
          dataField="ukupnokartonanapaleti"
          caption="Kartona"
          [width]="100"
        ></dxi-column>
        <dxi-column
          dataField="ukupanbrojpaleta"
          caption="Paleta"
          [width]="100"
        ></dxi-column>
      </dx-data-grid>
    </div>
  </div>

  <div class="customTable nadzornaPloca m-40 toolbar45">
    <div id="data-grid-demo">
      <dx-data-grid
        id="gridContainer"
        [dataSource]="sirovine"
        [wordWrapEnabled]="true"
        [showColumnLines]="true"
        keyExpr="normativsifra"
        [showBorders]="false"
        (onToolbarPreparing)="onToolbarPreparingSirovine($event)"
      >
        <div *dxTemplate="let data of 'naslovTablice'">
          <div class="naslov">
            <h2 class="mb-0">Sirovine</h2>
          </div>
        </div>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxi-column
          dataField="normativsifra"
          caption="Šifra"
          [width]="150"
        ></dxi-column>
        <dxi-column
          dataField="normativstavske"
          caption="Stavka"
          [minWidth]="300"
        ></dxi-column>
        <dxi-column
          dataField="po_naziv_skladiste_sirovina"
          caption="Skladište"
          [width]="300"
        ></dxi-column>
        <dxi-column
          dataField="kolicinanormativ"
          caption="Količina"
          [width]="150"
        ></dxi-column>
        <dxi-column
          dataField="jedinicamjere_JM_SIFRA"
          caption="Jed."
          [width]="100"
        ></dxi-column>
        <dxi-column
          dataField="skladiste_sirovina"
          caption="Stanje skl. sirovina"
          [width]="150"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="za_minimum_skladiste_sirovina"
          caption="Signalna zaliha"
          [width]="150"
          alignment="center"
        ></dxi-column>
      </dx-data-grid>
    </div>
  </div>

  <div class="customTable nadzornaPloca m-40 toolbar45">
    <div id="data-grid-demo">
      <dx-data-grid
        id="gridContainer"
        [dataSource]="ambalaza"
        [wordWrapEnabled]="true"
        [showColumnLines]="true"
        keyExpr="artikl_ar_asifra_abbalaze"
        [showBorders]="false"
        (onToolbarPreparing)="onToolbarPreparingAmbalaza($event)"
      >
        <div *dxTemplate="let data of 'naslovTablice'">
          <div class="naslov">
            <h2 class="mb-0">Ambalaža</h2>
          </div>
        </div>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxi-column
          dataField="artikl_ar_asifra_abbalaze"
          caption="Šifra"
          [width]="150"
        ></dxi-column>
        <dxi-column
          dataField="ar_naziv"
          caption="Stavka"
          [minWidth]="300"
        ></dxi-column>
        <dxi-column
          dataField="ukupnoambalaza"
          caption="Količina"
          [width]="150"
        ></dxi-column>
        <dxi-column
          dataField="skladisteambalaze"
          caption="Stanje skladišta"
          [width]="150"
          alignment="center"
        ></dxi-column>
      </dx-data-grid>
    </div>
  </div>
</div>
